<template>
    <div class="d-flex flex-column align-center justify-center fill-height ">
        <v-progress-circular
                :size="50"
                color="secondary"
                indeterminate
        ></v-progress-circular>
        <h3 class="pt-4 text-center" v-if="label" v-html="label"></h3>
    </div>
</template>

<script>
export default {
    props: {
        label: String
    },
}
</script>

<style scoped>

</style>